import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16986647"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "additionalFields",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Public Records Additional Fields")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert alert-primary text-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Customize the data points used to populate Additional Fields from Public Records.")
], -1))
const _hoisted_6 = { class: "font-weight-bold clear" }
const _hoisted_7 = { class: "form-group clear mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "delimiter-span" }, "Delimiter:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataAdditionalFields.additionalFields, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.displayName
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.displayName), 1),
                _createVNode(_component_Multiselect, {
                  modelValue: item.selected,
                  "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                  mode: "tags",
                  options: _ctx.dataAdditionalFields.dataPoints,
                  valueProp: "name",
                  label: "name",
                  max: "4",
                  searchable: true,
                  onSelect: ($event: any) => (_ctx.captureChange(item.selected, index)),
                  onDeselect: ($event: any) => (_ctx.captureChange(item.selected, index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSelect", "onDeselect"]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Multiselect, {
                    modelValue: item.delimiter,
                    "onUpdate:modelValue": ($event: any) => ((item.delimiter) = $event),
                    options: _ctx.delimeterOptions,
                    mode: "single",
                    class: "delimiter",
                    canClear: false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChanges()))
            }, "Save"),
            _hoisted_9
          ]),
          _: 1
        }),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              showLBackDrop: true,
              showLoadingText: true,
              loadingText: "Saving..."
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}